import { render } from "./PasoCuatro.vue?vue&type=template&id=fa2e5620&scoped=true"
import script from "./PasoCuatro.vue?vue&type=script&lang=js"
export * from "./PasoCuatro.vue?vue&type=script&lang=js"

import "./PasoCuatro.vue?vue&type=style&index=0&id=fa2e5620&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa2e5620"]])

export default __exports__